"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _TwoWayTransition = _interopRequireDefault(require("../../transitions/TwoWayTransition"));

var _component = _interopRequireDefault(require("../../utils/propTypes/component"));

var _ModalTransitionContext = require("../../context/ModalTransitionContext");

var _times = require("HubStyleTokens/times");

var _sizes = require("HubStyleTokens/sizes");

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  transition-property: ", ";\n  transition-duration: ", "ms;\n  transform: ", ";\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  z-index: ", ";\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var duration = parseInt(_times.PANEL_TRANSITION_TIMING, 10);

var getTransform = function getTransform(align, hidden) {
  if (hidden) {
    if (align === 'left') return 'translateX(-100%)';
    if (align === 'right') return 'translateX(100%)';
  }

  return 'translateX(0%)';
};

var PanelTransitionWrapper = (0, _styledComponents.default)(function (props) {
  var __align = props.align,
      hidden = props.hidden,
      transitioning = props.transitioning,
      rest = (0, _objectWithoutProperties2.default)(props, ["align", "hidden", "transitioning"]);
  return _react.default.createElement(_TwoWayTransition.default.PlainWrapper, (0, _extends2.default)({
    "data-component-name": "UIPanel",
    "data-open-complete": !hidden && !transitioning
  }, rest));
}).withConfig({
  displayName: "PanelTransition__PanelTransitionWrapper",
  componentId: "ego5xm-0"
})(_templateObject(), function (_ref) {
  var transitionActive = _ref.transitionActive;
  return transitionActive ? 'transform' : 'none';
}, duration, function (_ref2) {
  var align = _ref2.align,
      hidden = _ref2.hidden;
  return getTransform(align, hidden);
}, _sizes.JUPITER_LAYER, function (_ref3) {
  var align = _ref3.align;
  return align === 'right' ? 'right: 0;' : 'left: 0;';
});

var PanelTransition =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(PanelTransition, _React$Component);

  function PanelTransition() {
    (0, _classCallCheck2.default)(this, PanelTransition);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(PanelTransition).apply(this, arguments));
  }

  (0, _createClass2.default)(PanelTransition, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(_TwoWayTransition.default, (0, _extends2.default)({}, this.props, {
        ContextProvider: _ModalTransitionContext.ModalTransitionContextProvider,
        duration: this.props.duration,
        transitionOnMount: true
      }));
    }
  }]);
  return PanelTransition;
}(_react.default.Component);

PanelTransition.propTypes = {
  align: _react.PropTypes.oneOf(['left', 'right']).isRequired,
  duration: _react.PropTypes.number.isRequired,
  Wrapper: _component.default.isRequired
};
PanelTransition.defaultProps = {
  align: 'right',
  duration: duration,
  Wrapper: PanelTransitionWrapper
};
PanelTransition.displayName = 'PanelTransition';
var _default = PanelTransition;
exports.default = _default;
module.exports = exports.default;